export default __webpack_public_path__ + "static/media/exitpolicyblank.c0faec85.svg";